import { render, staticRenderFns } from "./allocationStorehouseDetailList.vue?vue&type=template&id=5a1d94df&scoped=true"
import script from "./allocationStorehouseDetailList.vue?vue&type=script&lang=js"
export * from "./allocationStorehouseDetailList.vue?vue&type=script&lang=js"
import style0 from "./allocationStorehouseDetailList.vue?vue&type=style&index=0&id=5a1d94df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1d94df",
  null
  
)

export default component.exports